import React, {useState} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import styled from "styled-components";
import ActionCreators from "../../store/actions";
import ConfirmUserDelete from "../ClientsTableComponent/ConfirmUserDelete";

const ActionSpan = styled.span`
  cursor: pointer;
  color: blue;
  text-decoration: underline;
`;

const PopperComponent = props => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const {
        anchorEl,
        displayPopover,
        resetPosition,
        date_od,
        date_do,
        potwierdzony,
        operator,
        klient,
        id
    } = props;


    return (
        <>
            <Popper
                open={displayPopover}
                key={resetPosition}
                keepMounted={false}
                placement={"bottom"}
                anchorEl={anchorEl}
                style={{
                    zIndex: 9999
                }}
            >
                <Paper
                    onMouseEnter={() => {
                        props.setPopoutValue({displayPopover: true});
                    }
                    }
                    onMouseLeave={() => props.setPopoutValue({displayPopover: false})}
                    onClick={e => e.stopPropagation()}
                    style={{
                        backgroundColor: "rgba(234, 237, 242, 0.9)",
                        marginLeft: "10px",
                        marginRight: "10px",
                        padding: "20px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                    >
                        <ActionSpan
                            onClick={e => {
                                e.stopPropagation();
                                props.setPopoutValue({displayPopover: false});
                                props.editRentHandler(id);
                            }}
                        >
                            Edytuj
                        </ActionSpan>
                        <ActionSpan
                            onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                props.setPopoutValue({displayPopover: false});
                                setDialogOpen(true);
                            }}
                        >
                            Usuń
                        </ActionSpan>
                    </div>
                    <div>Operator: {operator}</div>
                    <div style={{marginBottom: "10px"}}>Wynajety przez: {klient}</div>

                    <div>Od dnia: {date_od}</div>
                    <div style={{marginBottom: "10px"}}>Do dnia: {date_do}</div>

                    <div>Potwierdzone: {(potwierdzony === true || potwierdzony === 'true') ? 'Tak' : 'Nie'}</div>

                </Paper>
            </Popper>
            <ConfirmUserDelete
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false)
                    props.setPopoutValue({displayPopover: true});                }}
                onSubmit={() => {
                    props.cancelRentHandler(id);
                    setDialogOpen(false)
                    props.setPopoutValue({displayPopover: false});
                }}
            />
        </>
    );
};

const mapStateToProps = state => {
    return {
        ...state.popoutReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators(ActionCreators, dispatch),
        setPopoutValue: value =>
            dispatch({type: "SET_POPOUT_DATA", value: value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PopperComponent);
